module.exports = __webpack_public_path__ + "static/restaurant3-32d6edff6587a9322ab2e4f01abc0e2a.jpg";